import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { getCategoryAction } from '../../redux/toolkit/category/getCategory'
import { deleteCategoryAction } from '../../redux/toolkit/category/deleteCategory'
import PropTypes from 'prop-types';

export default function ReStoreCategory({ cat_id, state, setState, resetCatSeq }) {
    // state
    const dispatch = useDispatch()
    const restoreCat = useSelector(state => state.deleteCategory)
    const { status, message } = restoreCat

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        const restoreCat = await dispatch(deleteCategoryAction({ cat_id: cat_id,is_delete:false }))
        if (restoreCat.payload?.status == 200) {
            await dispatch(getCategoryAction({ is_deleted: true }))
            resetCatSeq()
        }
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>ReStore item request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to restore the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>

            {console.count("message",message)}
            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}

ReStoreCategory.propTypes = {
    cat_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any,
    resetCatSeq: PropTypes.any
};
